{
  "App": "التطبيق",
  "Profile": "ملف التعريف",
  "My Account": "حسابي",
  "Contacts": "جهات الاتصال",
  "Preferences": "التفضيلات",
  "Family Language": "لغة الأسرة",
  "Program Consent": "الموافقة على البرنامج",
  "Yes": "نعم",
  "No": "لا",
  "Not submitted": "لم يتم إرسالها",
  "See anything missing? Contact your Caring Adult": "هل لاحظت أي شيء مفقود؟ تواصل مع مسؤول الرعاية البالغ لديك",
  "Messages": "الرسائل",
  "Caring Adult for": "مسؤول الرعاية البالغ لـ",
  "Former Caring Adult for": "مسؤول الرعاية البالغ السابق لـ",
  "Write your message here...": "...اكتب رسالتك هنا",
  "I need help with": "احتاج إلى المساعدة بخصوص",
  "Academic": "المواد الأكاديمية",
  "After School/ Out of School": "فترة ما بعد المدرسة/خارج المدرسة",
  "Applying for benefits": "التقديم للحصول على المزايا",
  "Childcare": "رعاية الأطفال",
  "Employment / Adult Education": "التوظيف/تعليم البالغين",
  "Food": "الطعام",
  "Housing": "السكن",
  "Legal services": "الخدمات القانونية",
  "Material Resources / Clothing / Laundry": "الموارد المادية/الملابس/الغسيل",
  "Mental/emotional health": "الصحة العقلية/العاطفية",
  "Physical health/asthma": "الصحة البدنية/الربو",
  "Transportation": "النقل",
  "Send": "إرسال",
  "Today": "اليوم",
  "No messages yet": "لا توجد رسائل بعد",
  "No messages": "لا توجد رسائل",
  "Start a conversation below": "ابدء محادثة أدناه",
  "This Caring Adult is no longer available": "لم يعد مسؤول الرعاية البالغ متاحًا",
  "No longer available ": "لم يعد متاحًا ",
  "Monday": "الإثنين",
  "Tuesday": "الثلاثاء",
  "Wednesday": "الأربعاء",
  "Thursday": "الخميس",
  "Friday": "الجمعة",
  "Saturday": "السبت",
  "Sunday": "الأحد",
  "Emergency Contacts": "أطراف الاتصال في حالة الطوارئ",
  "Supervisor of Social Workers for the Bronx": "مشرف الأخصائيين الاجتماعيين في البرونكس",
  "Student Services Manager, High School District": "مدير خدمات الطلاب في المنطقة التعليمية للمدارس الثانوية",
  "Social Worker, Central Crisis Support Team": "أخصائي اجتماعي، فريق دعم الأزمات المركزي (Central Crisis Support Team)",
  "Support Line": "خط الدعم",
  "Suicide and Crisis Lifeline": "خط الحفاظ على الحياة في حالات الانتحار والأزمات (Suicide and Crisis Lifeline)",
  "Emergencies": "حالات الطوارئ",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "إذا كنت تواجه حالة طوارئ مهددة للحياة وتحتاج إلى المساعدة الآن، فاتصل أو أرسل رسالة نصية إلى 911",
  "About New Visions": "نبذة عن مبادرة (New Visions)",
  "Privacy and Terms": "الخصوصية والشروط",
  "Homepage": "الصفحة الرئيسية",
  "Home Page": "الصفحة الرئيسية",
  "My family": "أسرتي",
  "Available Services": "الخدمات المتاحة",
  "Grade": "الصف",
  "School": "المدرسة",
  "Attendance this year": "معدل الحضور لهذا العام",
  "Absences last 5 days": "حالات الغياب في آخر 5 أيام",
  "Caring Adult": "مسؤول الرعاية البالغ",
  "Message": "الرسالة",
  "Not available": "لم يعد متاحًا",
  "Not yet assigned": "لم يتم تعيينه بعد",
  "No absences": "لا توجد حالات غياب",
  "Phone not available": "رقم الهاتف غير متاح",
  "Email address not available": "عنوان البريد الإلكتروني غير متاح",
  "January": "يناير/ كانون الثاني",
  "February": "فبراير/ شباط",
  "March": "مارس/ آذار",
  "April": "أبريل/ نيسان",
  "May": "مايو/ أيار",
  "June": "يونيو/ حزيران",
  "July": "يوليو/ تموز",
  "August": "أغسطس/ آب",
  "September": "سبتمبر/ أيلول",
  "October": "أكتوبر/ تشرين الأول",
  "November": "نوفمبر/ تشرين الثاني",
  "December": "ديسمبر/ كانون الأول",
  "Sidenav": "التصفح الجانبي",
  "Home": "الصفحة الرئيسية",
  "Log out": "تسجيل الخروج",
  "Accessibility": "إمكانية الوصول",
  "Skip to main content": "تخطى للانتقال إلى المحتوى الرئيسي",
  "Email": "البريد الإلكتروني",
  "Phone": "رقم الهاتف",
  "Family Portal": "بوابة الأسرة",
  "Every Child and Family is Known": "برنامج تضمين جميع الأطفال والأسر",
  "Family Portal: Every Child and Family is Known": "بوابة الأسرة: برنامج تضمين جميع الأطفال والأسر",
  "Close menu": "إغلاق القائمة",
  "Open menu": "فتح القائمة",
  "Notes": "ملاحظات",
  "Send message": "إرسال رسالة",
  "Languages": "اللغات",
  "Consent status": "حالة الموافقة",
  "Select": "تحديد",
  "Language selector": "مُحدِّد اللغة",
  "Sorry": "عذرًا",
  "we couldn't find that page": "للم نتمكن من العثور على تلك الصفحة",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "أنت غير مصرح لك بعد بالدخول إلى بوابة العائلة. يرجى التواصل مع الشخص البالغ الذي يقدم الرعاية لك للوصول."
}